import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { getDistributor, INTL_LOCALES } from '@raisin/cp-utils';
import { RiskBanner } from 'components/RiskBanner/v2';
import { BANK_EVENTS, BANK_PAGES, trackBankDetailsPageClick } from 'eventsTracking';
import { useProductsAccess } from 'hooks';
import { DBSProduct } from 'types';
import { prepareDepositTakingBank } from 'utils/bankPageUtils';
import { getMarketingProductType } from 'utils/getMarketingProductType';
import messages from '../messages';
import { OfferDetailField } from '../types';
import BankOffersDetailField from './BankOffersDetailField';
import * as S from './styles';

export interface BankOffersDetailTabPanelProps {
  fields: OfferDetailField[];
  offer: DBSProduct;
  tabId: string;
}

export const BankOffersDetailTabPanel: React.FC<BankOffersDetailTabPanelProps> = ({
  fields,
  offer,
  tabId,
}) => {
  const { locale, formatNumber } = useIntl();
  const { conditions } = offer;
  const {
    riskBannerMainHeading,
    riskBannerStatutoryGuaranteeText,
    riskBannerEarlyTerminationAvailableText,
    riskBannerEarlyTerminationNotAvailableText,
  } = messages;
  const { distributorId } = useProductsAccess();

  useEffect(() => {
    const eventName =
      tabId === 'interest'
        ? BANK_EVENTS?.OFFER_ROW_INTEREST_TAB_CLICKED
        : BANK_EVENTS?.OFFER_ROW_INVESTMENT_TAB_CLICKED;
    const object =
      tabId === 'interest' ? 'offer_row_interest_tab' : 'offer_row_investment_amount_tab';

    trackBankDetailsPageClick({
      distributorId: distributorId || getDistributor(),
      eventName,
      object,
      bank_id: offer?.deposit_taking_bank?.id,
      productId: offer?.id,
      product_type: getMarketingProductType(offer),
      interestRates: {
        interest_rate_nominal: offer?.interest_rates?.interest_rate_nominal,
        interest_rate_effective: offer?.interest_rates?.interest_rate_effective,
      },
      bankPage: BANK_PAGES.PRODUCT_PAGE,
    });
  }, [tabId, offer, distributorId]);

  return (
    <S.DetailsContainer container>
      <S.RiskBannerContainer xs={12} lg={9}>
        {locale === INTL_LOCALES.SPAIN && (
          <RiskBanner
            productType={getMarketingProductType(offer)}
            formatNumber={formatNumber}
            depositTakingBank={prepareDepositTakingBank(offer)}
            isEarlyTerminationAvailable={conditions.termination.contractual_termination_allowed}
            content={{
              riskBannerMainHeading,
              riskBannerStatutoryGuaranteeText,
              riskBannerEarlyTerminationAvailableText,
              riskBannerEarlyTerminationNotAvailableText,
            }}
          />
        )}
      </S.RiskBannerContainer>
      {fields.map((field, index) => (
        <BankOffersDetailField
          field={field}
          key={field.id}
          isLastField={index !== fields?.length - 1}
        />
      ))}
    </S.DetailsContainer>
  );
};
export default BankOffersDetailTabPanel;
